/*
 * VULCAN
 */
import { __assign } from "tslib";
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/rolesMappers";
import * as Parameters from "../models/parameters";
/** Class representing a Roles. */
var Roles = /** @class */ (function () {
    /**
     * Create a Roles.
     * @param {SecurityContext} client Reference to the service client.
     */
    function Roles(client) {
        this.client = client;
    }
    Roles.prototype.getRoles = function (options, callback) {
        return this.client.sendOperationRequest({
            options: options
        }, getRolesOperationSpec, callback);
    };
    Roles.prototype.createRole = function (request, options, callback) {
        return this.client.sendOperationRequest({
            request: request,
            options: options
        }, createRoleOperationSpec, callback);
    };
    Roles.prototype.getRole = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, getRoleOperationSpec, callback);
    };
    Roles.prototype.updateRole = function (id, request, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            request: request,
            options: options
        }, updateRoleOperationSpec, callback);
    };
    Roles.prototype.deleteRole = function (id, options, callback) {
        return this.client.sendOperationRequest({
            id: id,
            options: options
        }, deleteRoleOperationSpec, callback);
    };
    Roles.prototype.getRolePermissions = function (roleName, options, callback) {
        return this.client.sendOperationRequest({
            roleName: roleName,
            options: options
        }, getRolePermissionsOperationSpec, callback);
    };
    return Roles;
}());
export { Roles };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var getRolesOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/roles",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "RoleResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var createRoleOperationSpec = {
    httpMethod: "POST",
    path: "api/v10/roles",
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateRoleRequest), { required: true })
    },
    responses: {
        201: {
            bodyMapper: Mappers.RoleResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getRoleOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/roles/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        200: {
            bodyMapper: Mappers.RoleResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var updateRoleOperationSpec = {
    httpMethod: "PUT",
    path: "api/v10/roles/{id}",
    urlParameters: [
        Parameters.id
    ],
    requestBody: {
        parameterPath: "request",
        mapper: __assign(__assign({}, Mappers.CreateOrUpdateRoleRequest), { required: true })
    },
    responses: {
        200: {
            bodyMapper: Mappers.RoleResponse
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var deleteRoleOperationSpec = {
    httpMethod: "DELETE",
    path: "api/v10/roles/{id}",
    urlParameters: [
        Parameters.id
    ],
    responses: {
        204: {},
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
var getRolePermissionsOperationSpec = {
    httpMethod: "GET",
    path: "api/v10/roles/{roleName}/permissions",
    urlParameters: [
        Parameters.roleName
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "PermissionResponse"
                        }
                    }
                }
            }
        },
        default: {
            bodyMapper: Mappers.ServiceErrorResponse
        }
    },
    serializer: serializer
};
//# sourceMappingURL=roles.js.map